const blogs = [
  {
    id: 1,
    date: "2024-12-27",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "nagad 777 অ্যাপে নতুন বছরের বোনাস অফার",
    descr:
      "নতুন বছরে nagad 777 অ্যাপে সেরা বোনাস পেতে সাইন আপ করুন। বিশেষ অফার এবং পুরস্কারের বিস্তারিত জানতে পড়ুন।",
    fullText:
      "nagad 777 অ্যাপটি গেমারদের জন্য নতুন বছরের শুরুতে একটি বিশেষ অফার নিয়ে এসেছে।\n\nআপনি যদি এখনও আমাদের অ্যাপে সাইন আপ না করে থাকেন, তাহলে এখনই সাইন আপ করুন এবং সেরা বোনাস উপভোগ করুন।\n\nবোনাস পাওয়ার জন্য সহজ স্টেপ গুলো ফলো করুন এবং nagad 777 অ্যাপের সব গেমিং সুযোগের আনন্দ উপভোগ করুন।\n\nঅ্যাপটি ডাউনলোড করা খুবই সহজ এবং এটি ব্যবহারকারীদের নিরাপত্তার ক্ষেত্রে অত্যন্ত উন্নত।\n\nnagad 777 অ্যাপের মাধ্যমে লাইভ গেম খেলুন এবং নতুন বছরের উপহার উপভোগ করুন।\n\nএই অফারটি সীমিত সময়ের জন্য প্রযোজ্য, তাই দেরি না করে এখনই যোগ দিন।\n\nনতুন বছরকে আনন্দময় করতে এবং আপনার প্রিয় গেম খেলতে আমাদের অ্যাপটি ব্যবহার করুন।\n\nবিশেষ করে নতুন ব্যবহারকারীদের জন্য অতিরিক্ত বোনাস পাওয়ার সুযোগ রয়েছে।",
  },
  {
    id: 2,
    date: "2024-12-25",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "nagad 777 ফরচুন টাইগার গেমে বড় জয়ের টিপস",
    descr:
      "ফরচুন টাইগার গেমে কৌশলগতভাবে খেলুন এবং বড় জয়ের সুযোগ নিন। বিস্তারিত জানতে পড়ুন।",
    fullText:
      "ফরচুন টাইগার গেমটি nagad 777-এর অন্যতম জনপ্রিয় গেম।\n\nএই গেমে বড় পুরস্কার জেতার জন্য কিছু বিশেষ কৌশল অনুসরণ করুন।\n\nপ্রথমত, গেমের নিয়ম ভালোভাবে বুঝে নিন। এটি আপনাকে আপনার কৌশল তৈরি করতে সাহায্য করবে।\n\nদ্বিতীয়ত, কম বাজি দিয়ে শুরু করুন এবং ধীরে ধীরে বাজি বাড়ান।\n\nবড় জয়ের জন্য বিশেষ রাউন্ডে মনোযোগ দিন। টাইমিং এবং সঠিক সিদ্ধান্ত আপনার জয়ের চাবিকাঠি।\n\nএছাড়াও, ফরচুন টাইগারের শক্তি ব্যবহার করুন এবং আপনার স্কোর বাড়ান।\n\nনিয়মিত অনুশীলন এবং সঠিক কৌশল আপনাকে এই গেমে সফল হতে সাহায্য করবে।\n\nnagad 777 অ্যাপে এই গেমটি খেলুন এবং সেরা অভিজ্ঞতা উপভোগ করুন।\n\nবড় পুরস্কারের সুযোগ নিয়ে নতুন বছরের আনন্দ বাড়ান।",
  },
  {
    id: 3,
    date: "2024-12-20",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "nagad 777 অ্যাভিয়েটর গেম: নতুনত্ব এবং মজা",
    descr:
      "অ্যাভিয়েটর গেমে কৌশলগত খেলার মাধ্যমে জয়ের আনন্দ উপভোগ করুন। বিস্তারিত জানতে পড়ুন।",
    fullText:
      "অ্যাভিয়েটর গেমটি একটি উচ্চ উত্তেজনাপূর্ণ গেম যা nagad 777 অ্যাপের অংশ।\n\nএই গেমে আপনার কৌশল ব্যবহার করে বড় পুরস্কার জেতার সুযোগ রয়েছে।\n\nগেমের নিয়ম সহজ এবং ব্যবহারকারীদের জন্য আকর্ষণীয়।\n\nআপনার বাজি নির্ধারণ করুন এবং প্লেনের গতিবিধি অনুযায়ী সঠিক সময়ে ক্লিক করুন।\n\nঅ্যাভিয়েটর গেমে টাইমিং খুবই গুরুত্বপূর্ণ। এটি আপনাকে বড় স্কোর অর্জন করতে সাহায্য করবে।\n\nnagad 777 অ্যাপে এই গেমটি খেলুন এবং নতুন বছরের বিশেষ বোনাস উপভোগ করুন।\n\nএই গেমটি লাইভ খেলার সুযোগ দেয় যা গেমারদের জন্য বিশেষ আকর্ষণীয়।\n\nঅ্যাভিয়েটর গেম খেলতে আজই সাইন আপ করুন এবং আপনার দক্ষতা পরীক্ষা করুন।",
  },
  {
    id: 4,
    date: "2024-12-15",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "nagad 777 ক্যাসিনো স্লটসের সেরা গেমস",
    descr:
      "nagad 777 ক্যাসিনোতে জনপ্রিয় স্লট গেম সম্পর্কে জানুন এবং নতুন বছরের বোনাস উপভোগ করুন।",
    fullText:
      "nagad 777 ক্যাসিনোতে সেরা স্লট গেমগুলো উপভোগ করুন।\n\nএই স্লট গেমগুলো উচ্চ মানের গ্রাফিক্স এবং আকর্ষণীয় থিম নিয়ে তৈরি।\n\nপ্রথমবারের ব্যবহারকারীদের জন্য ওয়েলকাম বোনাসের সুযোগ রয়েছে।\n\nলাইভ স্লট গেম খেলতে এবং আপনার স্কোর বাড়াতে নিয়মিত অনুশীলন করুন।\n\nবিশেষ করে নতুন বছরের জন্য স্লট গেমে বিশেষ অফার দেওয়া হয়েছে।\n\nনতুন ব্যবহারকারীরা সহজেই এই গেমগুলোতে প্রবেশ করতে পারেন।\n\nnagad 777 অ্যাপে এই গেমগুলো খেলুন এবং সেরা অভিজ্ঞতা উপভোগ করুন।\n\nস্লট গেমের মজার সাথে বড় জয়ের সুযোগ নিন।",
  },
  {
    id: 5,
    date: "2024-12-10",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "nagad 777 ব্লগে গেমিং টিপস এবং ট্রিকস",
    descr:
      "nagad 777 ব্লগে গেমিং জগতে আপনার দক্ষতা বাড়ানোর জন্য বিশেষ টিপস এবং ট্রিকস পড়ুন।",
    fullText:
      "nagad 777 ব্লগটি গেমারদের জন্য একটি বিশেষ প্ল্যাটফর্ম।\n\nএই ব্লগে আপনি গেমিং জগতে নতুনত্ব এবং টিপস সম্পর্কে জানতে পারবেন।\n\nনিয়মিত আমাদের ব্লগ পড়ুন এবং আপনার গেমিং দক্ষতা উন্নত করুন।\n\nগেমের নিয়ম এবং কৌশল নিয়ে বিস্তারিত লেখা এখানে পাওয়া যায়।\n\nনতুন বছরের জন্য বিশেষ টিপস এবং অফার সম্পর্কেও জানুন।\n\nলাইভ গেম খেলতে এবং বড় স্কোর করতে আমাদের নির্দেশনা অনুসরণ করুন।\n\nগেমিং জগতে আপনার অভিজ্ঞতা উন্নত করতে আমাদের ব্লগ একটি চমৎকার উৎস।\n\nআজই আমাদের ব্লগ পড়ুন এবং নতুন বছরের মজা উপভোগ করুন।",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);

  const imgColl = document.querySelectorAll("img");
  if (imgColl) {
    imgColl.forEach((img) => {
      if (img.closest(".logo")) return;
      if (img.closest(".santaBonus")) return;

      img.onclick = () =>
        window.location.assign("https://opimisil.com/D93Cd69X");
    });
  }
});
